import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M15.925 11.076a.6.6 0 0 1 0 .848l-4.5 4.5a.6.6 0 0 1-.849 0l-2-2a.6.6 0 1 1 .849-.848L11 15.15l4.076-4.075a.6.6 0 0 1 .849 0Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 4.4a6.602 6.602 0 0 0-6.425 5.084A5.101 5.101 0 0 0 6.5 19.6h11a5.1 5.1 0 0 0 .925-10.116A6.602 6.602 0 0 0 12 4.4Zm-5.328 5.717a5.402 5.402 0 0 1 10.656 0 .6.6 0 0 0 .537.5A3.9 3.9 0 0 1 17.5 18.4h-11a3.9 3.9 0 0 1-.365-7.783.6.6 0 0 0 .537-.5Z"
      clip-rule="evenodd"
    />
  </svg>
`;
